import React from 'react';

export const Logo = ({ isDark = false, className = '' }) => {
  // Using pure CSS filters to create a pristine white version of the logo for dark backgrounds.
  // We add a subtle drop shadow of the brand's pink accent color to maintain brand identity in dark mode.
  const darkThemeClasses = isDark 
    ? 'brightness-0 invert drop-shadow-[0_0_12px_rgba(246,220,232,0.3)]' 
    : '';

  return (
    <img
      src="https://media-manager-c.questera.ai/greta-media/9c5adfa6bba615730f4558013336717062b18ab46d11ed47c31c88c932e61ffbf11018f89f2243f6aef891f7c9f9eda4/images/aW1hZ2UvcG5n/aa548c32c3ceb7708fccbbcdbe97f155.png"
      alt="Silahub Technologies Inc."
      className={`object-contain transition-all duration-500 origin-left ${darkThemeClasses} ${className}`}
    />
  );
};